import ar from './ar.json'
import en from './en.json'
import fr from './fr.json'
import de from './de.json'

export const userLang = {en, fr, de, ar}
